import axios from './axios'

export const getBridgeUser = (personId) =>
  axios.get(`/bridge/users/${personId}`)

export const getBridgeUsers = (skip = 0, limit = 100) =>
  axios.get(`/bridge/users?skip=${skip}&limit=${limit}`)

export const getBridgeAllUsers = () => axios.get('/bridge/users/all')

export const createBridgeUser = (params) => axios.post('/bridge/users', params)

export const updateBridgeUser = (personId, params) =>
  axios.put(`/bridge/users/${personId}`, params)

export const deleteBridgeUser = (personId) =>
  axios.delete(`/bridge/users/${personId}`)

export const assignBridgeUserTeam = (personId, teamId, accessRole = 'athlete') =>
  axios.put(`/bridge/users/${personId}/teams/${teamId}`, { accessRole })

export const removeBridgeUserTeam = (personId, teamId) =>
  axios.delete(`/bridge/users/${personId}/teams/${teamId}`)

export const getBridgeTeams = (skip = 0, limit = 100) =>
  axios.get(`/bridge/teams?skip=${skip}&limit=${limit}`)

export const getBridgeWorkoutSets = ({
  personId,
  startDate,
  endDate,
  skip = 0,
  limit = 100
}) => {
  let query = `/bridge/workoutsets?personId=${personId}&skip=${skip}&limit=${limit}`
  if (startDate) query += `&startDate=${startDate}`
  if (endDate) query += `&endDate=${endDate}`
  return axios.get(query)
}

export const getBridgeFormResults = ({
  personId,
  startDate,
  endDate,
  skip = 0,
  limit = 100
}) => {
  let query = `/bridge/formresults?skip=${skip}&limit=${limit}`
  if (personId) query += `&personId=${personId}`
  if (startDate) query += `&startDate=${startDate}`
  if (endDate) query += `&endDate=${endDate}`
  return axios.get(query)
}

export const getBridgeCourseRegistrations = (
  startDate,
  endDate,
  skip = 0,
  limit = 100
) =>
  axios.get(
    `/bridge/courseregistrations?startDate=${startDate}&endDate=${endDate}&skip=${skip}&limit=${limit}`
  )

export const getBridgeTestResults = (
  startDate,
  endDate,
  skip = 0,
  limit = 100
) =>
  axios.get(
    `/bridge/testresults?startDate=${startDate}&endDate=${endDate}&skip=${skip}&limit=${limit}`
  )

export const triggerBridgeSync = (type, params = {}) => {
  const query = Object.keys(params)
    .filter((key) => params[key])
    .map((key) => `${key}=${params[key]}`)
    .join('&')
  const qs = query ? `?${query}` : ''
  return axios.post(`/bridge/sync/${type}${qs}`)
}
